import cookie from 'react-cookies';

import { COOKIE_DOMAIN, COOKIE_MAX_AGE_LONG, PLANK_COOKIE } from '~/src/constants';
import { getMobileLink } from '~/src/helpers/mobile';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { PLANK_IS_HIDDEN, PLANK_MOBILE_LINK_AND_TYPE } from '~/src/store/actionTypes/plank';

export const hidePlank = () => ({
    type: PLANK_IS_HIDDEN,
});

export const setPlankCookieAndClose = () => {
    return (dispatch: TAppThunkDispatch): void => {
        cookie.save(
            PLANK_COOKIE,
            1,
            {
                maxAge:COOKIE_MAX_AGE_LONG,
                domain:COOKIE_DOMAIN,
                path: '/',
            },
        );
        dispatch(hidePlank());
    };
};

export const location = [
    '/',
    '/user/login',
    '/payments',
    '/payments/lost',
    '/promo',
    '/action/pr',
    '/lk/feedback',
    '/service/contact',
    '/service/agent',
    '/service/document',
    '/service/helper',
];

export const smartHomeLocations = [
    '/domofon',
    '/videocontrol',
    '/payments/keys',
];

export const setMobileLinkAndPlankType = ({ pathname }: { pathname: string }) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const state = getState();
        const { city: { currentCity }, auth: { refreshToken, accessToken, clientPersonal } } = state;
        const { domain } = currentCity;
        const agreement = clientPersonal?.agreement;
        const mobileLink = !smartHomeLocations.includes(pathname)
            ? getMobileLink(accessToken, refreshToken, agreement, currentCity)
            : null;

        const plankType = (smartHomeLocations.includes(pathname)
            ? ({
                headerText: 'Умный Дом.ру',
                text: 'Управляйте домом в приложении',
                href: 'https://qr.dom.ru/domofon',
                linkName: 'Открыть',
                pic: 'static/images/domofon/AppIcon.png',
                domain,
            })
            : undefined);
        dispatch({
            type: PLANK_MOBILE_LINK_AND_TYPE,
            payload: { mobileLink, plankType },
        });
    };
};

export const getHasNotNotificationMobileAppCookie = () => !cookie.load(PLANK_COOKIE);

export const getIsActiveByTerms = (search: string) => {
    const params = new URLSearchParams(search);
    const utmSource = params.has('utm_source');

    return !utmSource;
};

export const getIsLocationByTerms = (pathname: string) => {
    return location.includes(pathname) || smartHomeLocations.includes(pathname);
};

